import { createApp } from 'vue'
import options from './ProductDetail.options'

const el = '.kb-component--product-detail'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((ProductDetailDOM) => {
            const template = ProductDetailDOM.outerHTML
            options.template = template
            const isSoldOut = ProductDetailDOM.hasAttribute('is-sold-out')
            const component = createApp(options, { isSoldOut }).use(Store)
            component.mount(ProductDetailDOM)
        })
    }
}
